import React from 'react';
import Button from '../../components/buttons/Button';
import Modal from '../../components/modal.v2/Modal';

import FbPixel from '../fbPixel/FbPixel';

export default class ConfirmacaoCartao extends React.Component{
  constructor(props){
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount(){
    const data = {};
    FbPixel.addTrack({event:'Purchase', data:{}});
    FbPixel.addCustomTrack({event:'purchase_cartao_web', data:{}});
  }

  handleSubmit(e){
    e.preventDefault();
    this.props.history.push('/area-restrita/bem-vindo/');
    Modal.destroy();
  }

  render(){
    return(
      <div>
        <div className='box-title'>
          <div className='title-parabens'>Parabéns</div>
          <div className='subtitle-parabens'>sua compra foi aprovada!</div>
        </div>
        <div className=''>
          <p><strong>Agora você faz parte da equipe Foco90.</strong></p><br />
          <p>
          {/*Este é um PRODUTO DIGITAL, você receberá os dados para acessá-lo via app ou email!<br /><br />*/}
Em caso de dúvidas ou necessidade de suporte relacionado ao produto / serviço, fique à vontade para entrar em contato com nosso suporte através do email <strong>contato@foco90.com.br</strong></p>
<br />
          <p>O link de WhatsApp será enviado para o seu email em até 15 minutos. Confira também no lixo eletrônico. Caso não chegue, envie email para contato@foco90.com.br.</p>
          <br />
          <br />
          <br />
            <Button
              text="Acessar meu treino"
              type='button'
              classes="button-login simple-button"
              onClick={this.handleSubmit}
            />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/classes/pagamento/ConfirmacaoCartao.js